const TOOL_MESSAGES = {
  propose_metric: 'Drafting a metric proposal...',
  remove_metric: 'Drafting a metric removal...',
  propose_rubric: 'Drafting a rubric proposal...',
  propose_prompt: 'Drafting a prompt proposal...'
}

function snapshotWorkspace (workspaceContext) {
  if (!workspaceContext) return { evalConfig: '', prompt: '', rubric: '', metrics: '' }

  const evalConfig = JSON.stringify({
    name: workspaceContext.name || '',
    sampleCount: workspaceContext.sampleCount,
    skillId: workspaceContext.skillId || '',
    skillTag: workspaceContext.skillTag || '',
    modelOverride: workspaceContext.modelOverride || '',
    judgeModelId: workspaceContext.judgeModelId || '',
    temperature: workspaceContext.temperature ?? null,
    focus: workspaceContext.focus || null
  })

  const metrics = JSON.stringify(
    (workspaceContext.metrics || []).map(m => ({
      name: m.name,
      type: m.type,
      description: m.description,
      weight: m.weight
    }))
  )

  return {
    evalConfig,
    prompt: workspaceContext.prompt || '',
    rubric: workspaceContext.rubric || '',
    metrics
  }
}

function snapshotToAttachments (snapshot) {
  const attachments = []
  if (snapshot.evalConfig) attachments.push({ name: 'evalConfig', content: snapshot.evalConfig })
  if (snapshot.prompt) attachments.push({ name: 'prompt', content: snapshot.prompt })
  if (snapshot.rubric) attachments.push({ name: 'rubric', content: snapshot.rubric })
  if (snapshot.metrics) attachments.push({ name: 'metrics', content: snapshot.metrics })
  return attachments
}

export function createAttachmentTracker () {
  let lastSent = null

  return {
    buildAttachments (workspaceContext) {
      const current = snapshotWorkspace(workspaceContext)
      if (lastSent &&
        current.evalConfig === lastSent.evalConfig &&
        current.prompt === lastSent.prompt &&
        current.rubric === lastSent.rubric &&
        current.metrics === lastSent.metrics
      ) {
        return []
      }
      lastSent = current
      return snapshotToAttachments(current)
    },

    reset () {
      lastSent = null
    }
  }
}

export const AGENT_CONFIGS = {
  'eval-designer': {
    agentId: 'eval-designer',
    label: 'Eval Designer',
    placeholder: 'Describe what you want to test...',
    editPlaceholder: 'Describe what you want to change...',
    toolMessages: TOOL_MESSAGES
  }
}

export function getAgentConfig (agentId) {
  return AGENT_CONFIGS[agentId] || AGENT_CONFIGS['eval-designer']
}
